import React from "react"
import { useFormikWizard } from "formik-wizard"

const checkProperties = (obj) => {
  for (let key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false
  }
  return true
}

const Nav = ({ currentStep, wizard }) => {
  const context = useFormikWizard()

  return (
    <div className="container">
      <div className="row">
        <div
          className={
            currentStep === "business_info"
              ? "contained col-lg-4"
              : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              wizard.push("business_info")
            }}
            className="btn"
            type="button"
          >
            Business Information
          </button>
        </div>

        <div
          className={
            currentStep === "other_info"
              ? "contained col-lg-4"
              : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              if (checkProperties(context.values.business_info)) {
                wizard.push("business_info")
              } else {
                wizard.push("other_info")
              }
            }}
            type="button"
            className="btn"
          >
            Stakeholders Information
          </button>
        </div>
        <div
          className={
            currentStep === "presenter_info"
              ? "contained col-lg-4"
              : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              if (checkProperties(context.values.business_info)) {
                wizard.push("business_info")
              } else if (checkProperties(context.values.other_info)) {
                wizard.push("other_info")
              } else {
                wizard.push("presenter_info")
              }
            }}
            className="btn"
            type="button"
          >
            Presenter Information
          </button>
        </div>
      </div>
    </div>
  )
}

export default Nav
